<template>
    <!-- 상단 -->
    <div class="inner-title">
        <div class="btn-favor " :class="isFavorItem?'on':''"  @click="onFavorClick" >즐겨찾기종목</div>        
        <div class="btn-search" @click="onGoserch">
            <router-link :to="{ name: ''}"><img src="@/assets/images/common/ico_search.png" alt="검색" /></router-link>
        </div>
        <div class="title">{{selectItem.KORNAME}}</div>
        
        <ul class="inner">
            <li :class="Constant.UTIL.getUpdownColor(Number(tradePrice) - prevClosingPrice)">
                <div class="price-box">
                    <div class="price">
                        {{ Constant.UTIL.numberWithCommas(Number(tradePrice).toFixed(getHtsNdotpos(selectItem.TYPE, tradePrice))) }}
                        <span class="unit">{{getUnit()}}</span>
                        <div class="num">
                            <!-- <span class="txt">전일대비</span> -->
                            <span class="per">
                            <i></i>{{Math.abs(tradingPerForCoin).toFixed(2) + '%'}}
                            </span>
                            <span class="rate">
                            {{ Constant.UTIL.numberWithCommas(Math.abs(Number(tradePrice) - prevClosingPrice).toFixed(getHtsNdotpos(selectItem.TYPE, tradePrice)))  }}
                            </span>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import {useApicall} from '@/composables/commonFn';
import { useStore } from 'vuex';
import { watch, getCurrentInstance, computed, ref, onMounted  } from 'vue';
 import { useRouter }from 'vue-router'
import Constant from '@/constant.js';
import {useCommonFunction} from '@/composables/vtradeFn';
export default {
    props:{
        selectItem:{     
                type:Object,
                required: true
        },
        pid:{     
                type:String,
                required: true
        },
    },
    setup(props)
    {
        //console.log("props:", props)
        const {   
            getNdotposCoin
        } = useCommonFunction();
        const  isFavorItem = ref(false)
        const store = useStore();
        const router = useRouter();
        const tradeObj = computed(() => store.state.hts.trade);
        const initData = computed(() => store.state.hts.initTrade);
        const internalInstance = getCurrentInstance(); 
        const emitter = internalInstance.appContext.config.globalProperties.emitter;       
        const tradePrice = ref(0);
        const prevClosingPrice = ref(0);
        const tradingPerForCoin = ref(0);
        const favorItemList = ref([]);
        const { apiCall_pt, apiCall_gt} = useApicall();
        emitter.off('EVENT_SOCKET_INIT_DATA_2')
        emitter.on('EVENT_SOCKET_INIT_DATA_2', () => {             
            if(props.selectItem.TYPE == 'G')
            {
                    let closePrice = Number(Constant.UTIL.removeTrash(initData.value.prevPrice24h));  
                    tradePrice.value =  Number(Constant.UTIL.removeTrash(initData.value.lastPrice));
                    if(!isNaN(closePrice)) 
                    {
                        prevClosingPrice.value = closePrice; 
                    } 
                    
                    let t_per_c = ( tradePrice.value - prevClosingPrice.value ) / prevClosingPrice.value * 100;
                    if(!isNaN(t_per_c)) tradingPerForCoin.value = t_per_c;              
                   
            }else{
                    let closePrice = Number(Constant.UTIL.removeTrash(initData.value.prev_closing_price));  
                    tradePrice.value =  Number(Constant.UTIL.removeTrash(initData.value.trade_price));
                    if(!isNaN(closePrice)) 
                    {
                        prevClosingPrice.value = closePrice; 
                    } 
                    if( props.selectItem.TYPE == "C" )
                    {
                        let t_per_c = ( tradePrice.value - prevClosingPrice.value ) / prevClosingPrice.value * 100;
                        if(!isNaN(t_per_c)) tradingPerForCoin.value = t_per_c;              
                    }
            }

        })

        watch(tradeObj, ()=>{
            //console.log("tradeObj :", tradeObj.value)
            if(props.selectItem.TYPE == 'G')
            {

                let t_price = Number(Constant.UTIL.removeTrash(tradeObj.value.price));                
                let t_per_c = (t_price - prevClosingPrice.value ) / prevClosingPrice.value * 100;        
                if(!isNaN(t_per_c)) tradingPerForCoin.value = t_per_c;  
                if(t_price)
                {
                    tradePrice.value = t_price;
                }


            }else{
                let t_price = Number(Constant.UTIL.removeTrash(tradeObj.value.trade_price));
                let t_prev_closing_price = Number(Constant.UTIL.removeTrash(tradeObj.value.prev_closing_price));
                let t_per_c = (t_price - t_prev_closing_price ) / t_prev_closing_price * 100;

        
                if(!isNaN(t_per_c)) tradingPerForCoin.value = t_per_c;  
                if(t_price)
                {
                    tradePrice.value = t_price;
                }
            }
        })


        const getUnit = ()=>{
          var result = 'KRW'
           if(props.selectItem.TYPE == 'G')
           {
             result = 'USDT'
           }
           else if(props.selectItem.TYPE == 'F')
           {
             result = ''
           }

           return result;
        }


        const onGoserch = () =>{
                var goName = null;
            if(props.selectItem.TYPE == 'C')
            {
                goName = 'ItemListCoin'; 
            }
            else if(props.selectItem.TYPE == 'S')
            {
                goName = 'ItemListStock';
            }
            else if(props.selectItem.TYPE == 'F')
            {
                goName = 'ItemListFutures';
            }
            else if(props.selectItem.TYPE == 'G')
            {
                goName = 'ItemListCoinFutures';
            }
            router.push({
                name: goName,  
                params: {
                    id:props.pid,  

                }                      
            })  
        }

        const addFavorList = async(_accountId, _tradeType, _code) =>{
          var params =   {
              "accountId": _accountId,
              "type": _tradeType,
              "code": _code
          }

          var res = await apiCall_pt(`vspace/favorateitemregister`, params, null, (message)=>{
            emitter.emit('EVENT_ALERT',{title:"알림", body:message});
          });
         // console.log("addFavorList: ", res)
          if(!res)return false   
          sessionStorage.setItem(`getfavor_${store.state.hts.currentAccountId}_${store.state.hts.currentTradeType}`, null) 
          return true;
        }

        const onFavorClick = async() =>{

            if(isFavorItem.value)
            {
                //관심종목 지움
                
                if(await removeFavorList(props.selectItem.CODE))
                {
                    isFavorItem.value = false;
                    emitter.emit('EVENT_ALERT',{title:"알림", body:"관심종목에서 삭제되었습니다."});
                }                
            }
            else
            {   
                //관심종목 추가
                if(!store.state.hts.currentAccountId)
                {
                    emitter.emit('EVENT_ALERT',{title:"알림", body:"대회 참가후 사용가능합니다."});
                    return;
                }
                
                if(await addFavorList(store.state.hts.currentAccountId, props.selectItem.TYPE, props.selectItem.CODE))
                {    
                    isFavorItem.value = true;                  
                    emitter.emit('EVENT_ALERT',{title:"알림", body:"관심종목에 추가되었습니다."});                    
                }               
                
            }
        }


   
        const removeFavorList = async(_code) =>{
          var params =   {
              "code": _code,
              "accountId":store.state.hts.currentAccountId
          }

          var res = await apiCall_pt(`vspace/favorateitemdelete`, params, null, (message)=>{
            emitter.emit('EVENT_ALERT',{title:"알림", body:message});
          });
          sessionStorage.setItem(`getfavor_${store.state.hts.currentAccountId}_${store.state.hts.currentTradeType}`, null) 
          if(!res)return false;
          return true;
        }
        const getFavorItemList = async() =>{
            favorItemList.value = [];            
            var res = JSON.parse(sessionStorage.getItem(`getfavor_${store.state.hts.currentAccountId}_${store.state.hts.currentTradeType}`));  
            if(!res)
            {
                res = await apiCall_gt(`vspace/getfavorateitemlist?accountId=${store.state.hts.currentAccountId}&type=${store.state.hts.currentTradeType}`);
                sessionStorage.setItem(`getfavor_${store.state.hts.currentAccountId}_${store.state.hts.currentTradeType}`, JSON.stringify(res)); 
            }
            if(!res) return false;
            favorItemList.value = res.favorateList;       
            
           // console.log("getFavorItemList:",  favorItemList.value)
            if(!favorItemList.value)favorItemList.value =[];

            isFavorItem.value = false
            favorItemList.value.forEach(_element => {
               // console.log("!!", _element.CODE,  props.selectItem.CODE )
                if( _element.CODE == props.selectItem.CODE)
                {
                    // console.log("!!222", _element.CODE,  props.selectItem.CODE )
                  isFavorItem.value = true
                }                          
            });
        }
   
       onMounted(()=>{
          setTimeout(getFavorItemList, 500)
          //getFavorItemList()
       })

        const getHtsNdotpos = (type, price = null) =>{
            var result = 0;
            if(type == 'C')
            {
               result = getNdotposCoin(price)
            }
            else if(type == 'F')
            {
                result = parseInt(props.selectItem.NDOTPOS);
            }
            else if(type == 'G')
            {
                result = parseInt(props.selectItem.NDOTPOS);
            }
            else if(type == 'S')
            {
                result = 0;
            }
            return result;
        }


        return{
          tradePrice,
          prevClosingPrice,
          tradingPerForCoin,
          Constant,
          getUnit,
          onGoserch,
          onFavorClick,
          isFavorItem,
          getHtsNdotpos
         
          
        }
    }

}
</script>

<style>

</style>